export default __webpack_public_path__ + "static/media/tiffi3big_thumb.a2efd149.jpg";